"use client";
import { jsx as _jsx } from "react/jsx-runtime";
// import components
import { Trans } from "react-i18next";
export const I18nTransAtomComponent = (props) => _jsx(Trans, { ...props });
export default I18nTransAtomComponent;
